S.stage =
    {
        elements: {
            $arrow: null,
        },
        init() {
            this.elements.$arrow.click(() => {
                this.scrollToText();
            })
        },
        scrollToText() {
            $(document).scrollTop($(".mod-text:first").offset().top);
        },
    }
;
